import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { OtherCodeResponse } from "@/Patient/Api/MedfarBilling/Dto/Responses/OtherCodeResponse";
import { ErrorFacturation, FacturationCode } from "@/Patient/Models/MedfarBilling/FacturationCode";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class MedfarBillingResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.MedfarBilling_LoadFavoriteCode, this.loadFavouriteCode);
        this.RegisterOperation(ServerOperations.Server.MedfarBilling_RemoveFavoriteCode, this.removeFavouriteCode);
        this.RegisterOperation(ServerOperations.Server.MedfarBilling_GenerateBill, this.generateBill);
        this.RegisterOperation(ServerOperations.Server.MedfarBilling_AddFavoriteCode, this.addFavouriteCode);
        this.RegisterOperation(ServerOperations.Server.MedfarBilling_VerifyAnnualGmfFee, this.verifyAnnualGmfFee);
    }

    private addFavouriteCode(response: ServerEvent, store: PatientStore): void {
        const isSpecialist = store.PatientMedicalNoteModels[response.PatientId].get("IsMedfarBillingSpecialist");
        store.ActionsMedfarBilling.LoadFavorite(isSpecialist);
    }

    private generateBill(response: ServerEvent, store: PatientStore): void {
        let noteModel = store.PatientMedicalNoteModels[response.PatientId];

        noteModel = noteModel.set("ShowNewMedfarBillPopup", false);

        store.PatientMedicalNoteModels[response.PatientId] = noteModel;
        store.ActionsMedicalNote.LoadMedfarBillForEncounter(noteModel.get("Encounter").Id);
    }

    private removeFavouriteCode(response: ServerEvent, store: PatientStore): void {
        const isSpecialist = store.PatientMedicalNoteModels[response.PatientId].get("IsMedfarBillingSpecialist");
        store.ActionsMedfarBilling.LoadFavorite(isSpecialist);
    }

    private loadFavouriteCode(response: ServerEvent, store: PatientStore): void {
        const favoriteList: OtherCodeResponse[] = response.Data.FavoriteCode;

        let noteModel = store.PatientMedicalNoteModels[response.PatientId];
        let medfarBillModel = noteModel.get("MedfarBillModel");

        const favoriteItems = {};
        if (favoriteList) {
            for (let n = 0; n < favoriteList.length; n++) {
                const newCode = new FacturationCode({
                    CodeGroupIdentifier: "FAVORIS--" + favoriteList[n].Code + n,
                    BaseCode: parseInt(favoriteList[n].Code),
                    Code: favoriteList[n].Code,
                    Description: favoriteList[n].Description,
                    UnitLabel1: favoriteList[n].UnitLabel1,
                    UnitLabel2: favoriteList[n].UnitLabel2,
                    UnitType1: favoriteList[n].UnitType1,
                    UnitType2: favoriteList[n].UnitType2,
                    TypeCode: favoriteList[n].TypeCode,
                    Attribut: favoriteList[n].Attribute
                });

                if (Object.keys(favoriteItems).indexOf(newCode.CodeGroupIdentifier) === -1) {
                    favoriteItems[newCode.CodeGroupIdentifier] = new FacturationCode;
                }

                favoriteItems[newCode.CodeGroupIdentifier] = newCode;
            }
        }
        medfarBillModel = medfarBillModel.set("FavoriteItems", favoriteItems);

        noteModel = noteModel.set("MedfarBillModel", medfarBillModel);
        store.PatientMedicalNoteModels[response.PatientId] = noteModel;
    }

    private verifyAnnualGmfFee(response: ServerEvent, store: PatientStore): void {
        const needsGmfAnnualFee: boolean = response.Data["NeedsGmfAnnualFee"];

        if (!needsGmfAnnualFee)
            return;

        const noteModel = store.PatientMedicalNoteModels[response.PatientId];
        const medfarBillModel = noteModel.get("MedfarBillModel");

        const codeList = medfarBillModel.get("CodesList").toArray();
        const autresList = medfarBillModel.get("AutresItems");

        let errors: ErrorFacturation[] = [];

        Object.keys(autresList).map((key: string) => {
            if (key === "AUTRES2--ForfaitGMFAnnuel") {
                autresList[key].IsChecked = !autresList[key].IsChecked;
                errors = autresList[key].RefreshCode(
                    errors,
                    medfarBillModel.get("IsMoreThan500"),
                    medfarBillModel.get("MoreThan1000Patient"),
                    medfarBillModel.get("MoreThan1500Patient"),
                    medfarBillModel.get("Is80YearsOld"),
                    medfarBillModel.get("IsVulnerable")
                );

                if (autresList[key].IsChecked) {
                    codeList.unshift(autresList[key]);
                }
            }
        });

        store.PatientMedicalNoteModels[response.PatientId] = noteModel.set(
            "MedfarBillModel",
            medfarBillModel
                .set("CodesList", Immutable.List(codeList))
                .set("AutresItems", autresList)
        );
    }
}

export { MedfarBillingResponseHandler };
